import {
  CAPABILITY_NAME,
  PROCESS_NAME,
  RFI_TYPE_SUPPLIER,
  SERVICE_NAME,
} from '../../common/commonConstants'

const trimCapabilityPopupSpecificationsRfi1 = {
  windowSize: 'dense',
  showCapabilities: true,
  showServiceCapabilities: false,
  options: [
    { label: 'Target Designated', value: 0 },
    { label: 'Vendor sourced', value: 1 },
  ],
  capabilityRowDisplayItems: {
    showPrimaryType: true,
    showSubType: true,
    capabilityTypeUid: CAPABILITY_NAME,
  },
}

const trimCapabilityPopupSpecificationsRfi2 = {
  windowSize: 'dense',
  showCapabilities: true,
  showServiceCapabilities: true,
  options: [
    { label: 'Target Designated', value: 0 },
    { label: 'Vendor sourced', value: 1 },
  ],
  capabilityRowDisplayItems: {
    showPrimaryType: true,
    showSubType: true,
    capabilityTypeUid: CAPABILITY_NAME,
  },
  serviceRowDisplayItems: {
    showPrimaryType: true,
    showSubType: false,
    capabilityTypeUid: SERVICE_NAME,
  },
}

const fabricCapabilityPopupDisplaySpecificationsRfi1 = {
  windowSize: 'dense',
  showCapabilities: true,
  showServiceCapabilities: false,
  options: [
    { label: 'Nominated', value: 0 },
    { label: 'Vendor sourced', value: 1 },
  ],
  capabilityRowDisplayItems: {
    showPrimaryType: true,
    showSubType: false,
    capabilityTypeUid: CAPABILITY_NAME,
  },
}

const fabricCapabilityPopupDisplaySpecificationsRfi2 = {
  windowSize: 'dense',
  showCapabilities: true,
  showServiceCapabilities: false,
  options: [
    { label: 'Nominated', value: 0 },
    { label: 'Vendor sourced', value: 1 },
  ],
  capabilityRowDisplayItems: {
    showPrimaryType: true,
    showSubType: false,
    capabilityTypeUid: PROCESS_NAME,
  },
}

const packagingCapabilityPopupDisplaySpecifications = {
  windowSize: 'default',
  showCapabilities: true,
  showServiceCapabilities: false,
  options: [
    { label: 'Target Approved', value: 0 },
    { label: 'Vendor Managed', value: 1},
    { label: 'GMI Certified', value: 2 },
  ],
  capabilityRowDisplayItems: {
    showPrimaryType: true,
    showSubType: false,
    capabilityTypeUid: CAPABILITY_NAME,
  },
}

/**
 * A mapper object that associates manufacturing type IDs with their corresponding capability popup specifications (RFI1)
 * @property {Function} 10 - Function to handle trim capability popup specifications.
 * @property {Function} 7 - Function to handle fabric capability popup display specifications.
 * @property {Function} 27 - Function to handle packaging capability popup display specifications.
 */
const manufacturingTypeCapabilitySpecificationMapperRfi1 = {
  10: trimCapabilityPopupSpecificationsRfi1,
  7: fabricCapabilityPopupDisplaySpecificationsRfi1,
  27: packagingCapabilityPopupDisplaySpecifications,
}

/**
 * A mapper object that associates manufacturing type IDs with their corresponding capability popup specifications (RFI2)
 * @property {Function} 10 - Function to handle trim capability popup specifications.
 * @property {Function} 7 - Function to handle fabric capability popup display specifications.
 * @property {Function} 27 - Function to handle packaging capability popup display specifications.
 */
const manufacturingTypeCapabilitySpecificationMapperRfi2 = {
  10: trimCapabilityPopupSpecificationsRfi2,
  7: fabricCapabilityPopupDisplaySpecificationsRfi2,
  27: packagingCapabilityPopupDisplaySpecifications,
}

/**
 * Retrieves the capability popup specification based on the given RFI type and manufacturing type ID.
 *
 * @param {string} rfiType - The type of RFI (Request for Information).
 * @param {number} manufacturingTypeId - The ID of the manufacturing type.
 * @returns {Object} The capability popup specification for the given manufacturing type ID.
 */
export const getCapabilityPopupSpecification = (
  rfiType,
  manufacturingTypeId,
) => {
  if (rfiType?.toLowerCase() === RFI_TYPE_SUPPLIER) {
    //Supplier Mapper
    return manufacturingTypeCapabilitySpecificationMapperRfi1[
      manufacturingTypeId
    ]
  } else {
    //Location/Questionnaire Mapper
    return manufacturingTypeCapabilitySpecificationMapperRfi2[
      manufacturingTypeId
    ]
  }
}
